import classNames from "classnames";
import Link from 'next/link';
import { FC, useContext, useState } from "react";
import { MdExpandMore, MdChevronRight } from "react-icons/md";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { API } from "../../../services/api/types";
import { deviceTypeContext } from "../../../utils/deviceTypeContext";
import slugify from '../../../utils/slugify';
import ImageListItem from "../../ListItems/ImageListItem";
import Table from "../../Table/Table";
import TableBody from "../../Table/TableBody";

type HistoryTableRow = {
  history: API.ManagerHistory;
  showBg: boolean;
};

const HistoryTableRow: FC<HistoryTableRow> = ({ history, showBg }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isAboveSm = useBreakpoint("sm", useContext(deviceTypeContext)!);

  const formatTableValue = (v: number) => (v < 1 ? "-" : v);

  return (
    <>
      <tr
        onClick={() => setIsExpanded(!isExpanded)}
        className={classNames(
          {
            "bg-black-lightest": showBg,
          },
          ["cursor-pointer"]
        )}
      >
        <td
          className={classNames(["w-[50px]", "sm:w-[65px]"])}
          style={{
            paddingRight: isAboveSm ? "1.25rem" : "1rem",
            paddingLeft: isAboveSm ? "1.25rem" : "1rem",
          }}
        >
          <MdExpandMore
            size={22}
            className={classNames(
              {
                "-rotate-180": isExpanded,
              },
              ["duration-200", "m-auto"]
            )}
          />
        </td>
        <td>
          {!isAboveSm && (
            <span className={classNames("mb-1.5", "block")}>
              {history.season}
            </span>
          )}
          <ImageListItem
            src={history.clubLogo}
            text={history.clubsName}
            imageStyle={["w-[25px]", "h-[25px]"]}
            textStyle={["font-bold"]}
          />
        </td>
        {isAboveSm && <td>{history.season}</td>}
        <td className={classNames("text-center")}>
          {formatTableValue(history.placement)}
        </td>
      </tr>
      {isExpanded && (
        <tr
          className={classNames({
            "bg-black-lightest": showBg,
          })}
        >
          <td colSpan={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Table>
              <TableBody alternateRowColor={false}>
                {history.leaguesName && <tr className={classNames("border-t")}>
                  <td className={classNames("w-[50px]", "sm:w-[65px]")}></td>
                  <td style={{ paddingLeft: 0 }}>
                    Liga: {history.leaguesName}
                  </td>
                </tr>}
                
                {history.roleName && <tr className={classNames("border-t")}>
                  <td className={classNames("w-[50px]", "sm:w-[65px]")}></td>
                  <td style={{ paddingLeft: 0 }}>
                    Roll: {history.roleName}
                  </td>
                </tr>}

                {history.clubsId > 0 && <tr className={classNames("border-t")}>
                  <td className={classNames("w-[50px]", "sm:w-[65px]")}></td>
                  <td style={{ paddingLeft: 0 }}>
                  <Link
                      href={`/klubbar/land/${slugify(history.clubsName)}/${
                        history.clubsId
                      }`}
                    >
                      <span className='flex items-center hover:underline font-semibold cursor-pointer'>
                        Gå till klubb <MdChevronRight size={20} />
                      </span>
                    </Link>
                  </td>
                </tr>}
              </TableBody>
            </Table>
          </td>
        </tr>
      )}
    </>
  );
};

export default HistoryTableRow;
